export function parseQueryString(
  search: string,
  name: string
): string | undefined {
  const searchParams = new URLSearchParams(search);

  return searchParams.get(name) ?? undefined;
}
